import { ListItemButton, ListItemIcon, MenuItem } from "@mui/material";

import { Link } from "react-router-dom";
import { colors } from "../../../../theme/globalStyles";
import styled from "styled-components";

interface Iprops {
    expaned: boolean | number;
    selected: boolean;
}

interface IPropsSub {
    menupai: string;
}

export const ItemButton = styled(MenuItem)<Iprops>`
  background: ${({ selected }) => {
      return selected ? "#fff !important;" : `${colors.blue} !important;`;
  }};
  color: ${({ selected }) => {
      return selected ? `${colors.blue} !important;` : "#fff !important;";
  }};
  margin: ${({ expaned }) => {
      return expaned ? "4px 16px !important;" : "4px 8px !important;";
  }} ;
  padding: ${({ expaned }) => {
      return expaned ? "15px 0px !important;" : "10px 0px !important;";
  }} ;
  
  display: flex !important ;
  justify-content: center !important;
  border: solid 0px #000 !important;
  border-radius:  5px !important;

  svg {
    color: ${({ selected }) => {
        return selected ? `${colors.blue} !important;` : "#fff !important;";
    }};
  }

  span {
    font-size: 16px
  }

  &:hover {
    background: ${colors.lightWhite} !important;
    color: #fff !important;
    svg {
      color: #fff !important;
    }
  }  
`;

export const ItemIcon = styled(ListItemIcon)`
  display: flex !important ;
  justify-content: center !important;
`;

export const Links = styled(Link)`
    text-decoration: none !important;

`;

export const ListItemSubMenu = styled(ListItemButton)<IPropsSub>`
  padding: 0px !important;
  font-size:14px !important;
  margin: 8px 0px !important;
  color: #fff !important;
  
  &:hover {
    text-decoration: underline !important;
    background: ${colors.blue} !important;
  }
`;
